export default "__VITE_ASSET__oZTTnNq0__"